import { EstadoEntidade } from "@/shared/enumeradores";
import axios from "./axios-handler.service";
const BASE_URL = "/api/Categorias";

export interface Categoria {
  estadoEntidade: EstadoEntidade;
  idCatalogo: string;
  idCategoria: string;
  idCategoriaPai: string;
  nome: string;
  categorias: Categoria[];
}

export class CategoriasService {
  static async obter(idCategoria: string): Promise<Categoria> {
    const response = await axios.get<Categoria>(`${BASE_URL}/Obter`, {
      params: { idCategoria },
    });
    return response.data;
  }

  static async listarCategorias(idCatalogo: string): Promise<Categoria[]> {
    const response = await axios.get<Categoria[]>(
      `${BASE_URL}/ListarCategorias`,
      {
        params: { idCatalogo },
      }
    );
    return response.data;
  }

  static async manterCategoria(categoria: Categoria): Promise<void> {
    await axios.post(BASE_URL + "/ManterCategoria", { categoria });
  }
  static async atualizarCatalogoConsultor(idCatalogo: string): Promise<void> {
    await axios.post(BASE_URL + "/AtualizarCatalogoConsultor", { idCatalogo });
  }
  static async excluirCategoria(
    idCategoria: string,
    idCategoriaNova: string
  ): Promise<void> {
    await axios.post(BASE_URL + "/ExcluirCategoria", {
      idCategoria,
      idCategoriaNova,
    });
  }

  static async existeProdutoPorCategoria(
    idCategoria: string
  ): Promise<boolean> {
    const response = await axios.get<boolean>(
      `${BASE_URL}/ExisteProdutoPorCategoria`,
      {
        params: { idCategoria },
      }
    );
    return response.data;
  }
}
